import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../feathers.service'
import { from, Observable } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

export interface MyPermittedAllocation {
  socialService: {
    id: number
    name: string
    socialServiceTypeCode: number
  }
  locations: {
    id: number
    name: string
    allocationId: number
  }[]
}

@Injectable({
  providedIn: 'root',
})
export class MyPermittedAllocationsService {
  private feathersService = inject(FeathersService)

  private readonly service = 'features/my-permitted-allocations'

  get(): Observable<MyPermittedAllocation[]> {
    const service = this.feathersService.service(this.service)
    return from(service.find()).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error in MyPermittedAllocationsService:', error)
        throw error
      }),
    )
  }
}
